import { render, staticRenderFns } from "./UserDetailsAdministrationIndividualUserRights.vue?vue&type=template&id=7572bc7c&scoped=true&"
import script from "./UserDetailsAdministrationIndividualUserRights.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAdministrationIndividualUserRights.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsAdministrationIndividualUserRights.vue?vue&type=style&index=0&id=7572bc7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7572bc7c",
  null
  
)

export default component.exports